import {
  Component,
  ViewEncapsulation,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Renderer2,
  Output,
  EventEmitter
} from '@angular/core';
import { ModalService } from '../../../core/services/modal/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
  element: any;
  hidden: boolean;

  @Input() id: string;
  @Output() closeModal = new EventEmitter<void>();
  @Input() cssModifier: string;

  constructor(
    public modalService: ModalService,
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    this.element.addEventListener('click', (el) => {
      if (el.target.className === 'lm-modal__container') {
        this.close();
      }
    });

    this.modalService.add(this.element);
    this.modalService.setRender(this.renderer);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);

    try {
      this.renderer.removeChild(document.body, this.element);
    } catch (e) {
      // Ignore DOM errors
    }
  }

  getRef(...args: string[]): string {
    return 'qa-' + args.join('-');
  }

  close(): void {
    this.modalService.close(this.id);
    if (this.closeModal) {
      this.closeModal.next();
    }
  }
}
